namespace Matrix.Dashboards {

    @Serenity.Decorators.registerEditor('Matrix.Dashboards.FieldSelect')
    export class FieldSelect extends Serenity.Select2Editor<any, any> {

        constructor(element: JQuery, opt: any) {
            super(element, Q.extend({ autoComplete: true}, opt));
        }
    }
}